class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    const catalogLink = this.querySelector('[data-bh-catalog-link]');
    if (catalogLink) {
      // Keep native link navigation separate from the summary toggle.
      catalogLink.addEventListener('click', (event) => event.stopPropagation());
      const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      this.addEventListener('mouseenter', () => {
        clearTimeout(this.catalogCloseTimer);
        if (!desktopHover.matches) return;
        this.mainDetailsToggle.open = true;
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      });
      const summary = this.mainDetailsToggle.querySelector('summary');
      const inside = (node, x, y) => {
        const box = node.getBoundingClientRect();
        return x >= box.left - 4 && x <= box.right + 4 && y >= box.top - 12 && y <= box.bottom + 4;
      };
      document.addEventListener('pointermove', (event) => {
        if (!desktopHover.matches || !this.mainDetailsToggle.open) return;
        clearTimeout(this.catalogCloseTimer);
        if (inside(summary, event.clientX, event.clientY) || inside(this.content, event.clientX, event.clientY) || inside(this.content.querySelector('.mega-menu__list') || this.content, event.clientX, event.clientY)) return;
        this.catalogCloseTimer = setTimeout(() => this.close(), 160);
      }, { passive: true });
      document.addEventListener('pointerdown', (event) => {
        if (this.mainDetailsToggle.open && !this.contains(event.target)) this.close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.mainDetailsToggle.open) {
          this.close();
          summary.focus();
        }
      });

    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.contains(document.activeElement) || this.content.matches(':hover') || this.mainDetailsToggle.querySelector('summary').matches(':hover')) return;
      this.close();
    }, 180);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
